import React from 'react'
import PrimaryButton from '../components/primary-button'
import { useNavigate } from 'react-router-dom'

export default function NotFound() {
    const navigate = useNavigate();
    return (
        <div className='page-size flex-center gap-4 p-4'>
            <p>
                404 Not Found
            </p>
            <PrimaryButton label={"Go Home"} onClick={() => navigate("/")} />
        </div>
    )
}
